import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api'
import type { TenantAtual } from '../types'

export function useTenantAtual() {
  return useQuery({
    queryKey: ['tenant-atual'],
    queryFn: async () => {
      const r = await api.get<TenantAtual>('/tenants/atual/')
      return r.data
    },
    staleTime: 1000 * 60 * 10,
  })
}

export function useTenantUpdate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: Partial<TenantAtual>) =>
      api.patch<TenantAtual>('/tenants/atual/', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tenant-atual'] }),
  })
}
